import { FC } from 'react';
import { SignPage } from './sign.component';
import { ESignTypes } from '../types';

interface IProps {}

export const LoginPage: FC<IProps> = () => <SignPage type={ESignTypes.LOGIN} />;
